import { makeStyles } from '@material-ui/styles';
import { SelectItemOverlay } from 'component/layout_quiz/select_item_overlay';

const useStyles = makeStyles({
    itemContainer: {
        width: 158,
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 5px',
        '@media (min-width: 768px)': {
            width: '100%',
        },
    },
    itemImg: {
        width: '100%',
        maxWidth: 158,
        height: 158,
        borderRadius: 8,
        '@media (min-width: 768px)': {
            maxWidth: 350,
            height: 350,
        },
        position: 'relative',
    },
});
export const GenderItem = ({ name, image, handleClick, isSelect }) => {
    const classes = useStyles();
    return (
        <div
            className={classes.itemContainer}
            onClick={handleClick}
            style={{
                borderRadius: '10px',
                background: isSelect ? '#1A1A1A' : 'transparent',
                transition: 'background 0.3s',
                padding: '4px',
            }}
        >
            <div
                className={classes.itemImg}
                style={{
                    // background: `${isSelect ? "#FFFCF0" : "#4A6C72"}`,
                    background: 'white',
                }}
            >
                <img
                    src={image}
                    alt="Gender"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
                />
                {isSelect && <SelectItemOverlay />}
            </div>
            <p
                style={{
                    marginTop: '4px',
                    marginBottom: '4px',
                    fontSize: 16,
                    fontWeight: `${isSelect ? 600 : 400}`,
                    fontFamily: 'PoppinsRegular',
                    color: isSelect ? '#F2F2F2' : '#1A1A1A',
                }}
            >
                {name}
            </p>
        </div>
    );
};
